import { LAYOUTS, } from "@voltmoney/types";
import { ButtonTypeTokens, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTIONS } from "./types";
import { checkUserType, editNumber, goBack } from "./actions";
import { sendOtp } from "../phone_number/actions";
import { Platform } from "react-native";
export const template = (phone_number, noOfOtpDigits, isWhatsAppEnabled, setIsUserLoggedIn, leadId, height, setApplicationState, setShowSupportPhoneNumber) => {
    return {
        layout: {
            id: ROUTE.OTP_VERIFY,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true,
            },
            widgets: [
                { id: "otpverifyScreen", type: WIDGET.OTP_VERIFY_PAGE }
            ],
        },
        datastore: {
            otpverifyScreen: {
                height,
                phoneNumber: phone_number,
                editAction: {
                    type: ACTIONS.EDIT,
                    payload: {},
                    routeId: ROUTE.OTP_VERIFY,
                },
                extraSpace: 20,
                title: "Enter OTP",
                type: InputTypeToken.OTP,
                state: InputStateToken.DEFAULT,
                keyboardType: KeyboardTypeToken.numberPad,
                charLimit: noOfOtpDigits,
                action: {
                    type: ACTIONS.LoginWithCognito,
                    routeId: ROUTE.OTP_VERIFY,
                    payload: {
                        username: `${phone_number}`,
                        isWhatsAppEnabled,
                        value: "",
                        widgetId: "input",
                        setIsUserLoggedIn,
                        leadId: leadId,
                        noOfOtpDigits: noOfOtpDigits,
                        setApplicationState: setApplicationState,
                        setShowSupportPhoneNumber: setShowSupportPhoneNumber,
                    },
                },
                otpAction: {
                    type: ACTIONS.RESEND_OTP_NUMBER,
                    payload: {
                        value: `${phone_number}`,
                        widgetId: "input",
                        isResend: true,
                    },
                    routeId: ROUTE.OTP_VERIFY,
                },
            },
            otpModalScreen: {
                id: 'tf_loginScreen_otp',
                isFocus: true,
                title: "Enter OTP",
                type: InputTypeToken.OTP,
                state: InputStateToken.DEFAULT,
                keyboardType: KeyboardTypeToken.numberPad,
                charLimit: noOfOtpDigits,
                caption: { error: "" },
                action: {
                    type: ACTIONS.LoginWithCognito,
                    routeId: ROUTE.OTP_VERIFY,
                    payload: {
                        username: `${phone_number}`,
                        password: "123456",
                        isWhatsAppEnabled,
                        value: "",
                        widgetId: "input",
                        setIsUserLoggedIn,
                        leadId: leadId,
                        noOfOtpDigits: noOfOtpDigits
                    },
                },
                otpAction: {
                    type: ACTIONS.RESEND_OTP_NUMBER,
                    payload: {
                        value: `${phone_number}`,
                        widgetId: "input",
                        isResend: true,
                    },
                    routeId: ROUTE.OTP_VERIFY,
                },
            },
            back: {
                type: ButtonTypeTokens.IconGhost,
                icon: { name: IconTokens.Back, size: IconSizeTokens.XL },
            },
            title: {
                label: "Enter OTP",
                fontSize: FontSizeTokens.XL,
                color: ColorTokens.Grey_Night,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: "600",
            },
            subTitleStack: {
                type: StackType.row,
                alignItems: StackAlignItems.center,
                justifyContent: StackJustifyContent.flexStart,
                widgetItems: [
                    { id: "subTitle", type: WIDGET.TEXT },
                    { id: "subTitle2", type: WIDGET.TEXT },
                    { id: "editNumber", type: WIDGET.TEXT },
                ],
                action: {
                    type: ACTIONS.EDIT,
                    payload: {},
                    routeId: ROUTE.OTP_VERIFY,
                },
            },
            space56: {
                size: Platform.OS === 'web' ? SizeTypeTokens.XXXL : SizeTypeTokens.XXXXXXL
            },
            titleStack: {
                type: StackType.column,
                widgetItems: [
                    { id: "space56", type: WIDGET.SPACE },
                    { id: "title", type: WIDGET.TEXT },
                ]
            },
            subTitle: {
                label: `6-digit OTP sent to `,
                color: ColorTokens.Grey_Charcoal,
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "400",
            },
            subTitle2: {
                label: `${phone_number}`.substring(3),
                color: ColorTokens.Grey_Charcoal,
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "600",
            },
            editNumber: {
                id: 'txt_loginScreen_edit',
                label: `   Edit`,
                color: ColorTokens.Primary_100,
                fontSize: FontSizeTokens.SM,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: "600",
                paddingLeft: 6,
                paddingRight: 6,
            },
            input: {
                isFocus: true,
                title: "Enter OTP",
                type: InputTypeToken.OTP,
                state: InputStateToken.DEFAULT,
                keyboardType: KeyboardTypeToken.numberPad,
                charLimit: noOfOtpDigits,
                id: 'tf_loginScreen_otp',
                action: {
                    type: ACTIONS.LoginWithCognito,
                    routeId: ROUTE.OTP_VERIFY,
                    payload: {
                        username: `${phone_number}`,
                        password: "123456",
                        isWhatsAppEnabled,
                        value: "",
                        widgetId: "input",
                        setIsUserLoggedIn,
                        leadId: leadId,
                        noOfOtpDigits: noOfOtpDigits
                    },
                },
                otpAction: {
                    type: ACTIONS.RESEND_OTP_NUMBER,
                    payload: {
                        value: `${phone_number}`,
                        widgetId: "input",
                        isResend: true,
                    },
                    routeId: ROUTE.OTP_VERIFY,
                },
            },
            space0: { size: SizeTypeTokens.XXXL },
            space1: { size: SizeTypeTokens.SM },
            space2: { size: SizeTypeTokens.XXXL },
        },
    };
};
export const otpVerifyMF = {
    onLoad: async ({ instrumentTrack, getHeight }, { phone_number, isWhatsAppEnabled, setIsUserLoggedIn, leadId, noOfOtpDigits, setApplicationState, setShowSupportPhoneNumber }) => {
        if (leadId) {
            instrumentTrack('SIGNUP_OTP_PAGE_VIEWED', { type: 'lead_form', phone: phone_number });
        }
        else {
            instrumentTrack('SIGNUP_OTP_PAGE_VIEWED', { type: 'direct' });
        }
        return Promise.resolve(template(phone_number, noOfOtpDigits, isWhatsAppEnabled, setIsUserLoggedIn, leadId, getHeight(), setApplicationState, setShowSupportPhoneNumber));
    },
    actions: {
        [ACTIONS.LoginWithCognito]: checkUserType,
        [ACTIONS.GO_BACK]: goBack,
        [ACTIONS.EDIT]: editNumber,
        [ACTIONS.RESEND_OTP_NUMBER]: sendOtp,
    },
    clearPrevious: true,
};
